var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.05 1.45 9.825 5.025C29.3 7.225 30.2 8.65 30.2 10.3v2.325h-3.6V10.3c0-.225-.15-.45-.375-.6L16.4 4.675c-.15-.075-.375-.075-.6 0L5.975 9.7c-.225.075-.375.3-.375.6v2.325H2V10.3c0-1.575.9-3.075 2.325-3.825L14.15 1.45c1.2-.6 2.625-.6 3.9 0zm1.125 14.4c0-1.725-1.425-3.075-3.075-3.075a3.04 3.04 0 0 0-3.075 3.075c0 1.725 1.425 3.075 3.075 3.075 1.65 0 3.075-1.35 3.075-3.075zm6.975 6.45c.225-.075.375-.3.375-.6v-2.325h3.6V21.7c0 1.575-.9 3.075-2.325 3.825l-9.825 5.025c-.6.3-1.275.45-1.95.45-.675 0-1.35-.15-1.95-.45l-9.75-5.025C2.9 24.775 2 23.35 2 21.7v-2.325h3.6V21.7c0 .225.15.45.375.6l8.325 4.2v-4.2c-2.85-.825-4.875-3.375-4.875-6.45 0-3.675 3-6.75 6.75-6.75 3.675 0 6.75 3 6.75 6.75 0 3.075-2.1 5.7-4.875 6.45v4.2l8.1-4.2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkr);
export default __webpack_public_path__ + "static/media/ANKR.169cd7a40dcf73587846a48eafafd3db.svg";
export { ForwardRef as ReactComponent };